var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelPhoto14 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M10.003 3c.55 0 .997.453.997.997v6.006c0 .55-.453.997-.997.997H3.997c-.55 0-.997-.453-.997-.997V3.997c0-.55.453-.997.997-.997zm-.994 1H4.991C4.45 4 4 4.444 4 4.99v4.02c0 .539.444.99.99.99h4.02c.539 0 .99-.444.99-.99V4.99c0-.539-.444-.99-.99-.99M6.06 6.685l2.06 2.247-.561-1.123.562-.562 1.123 1.31v.937H4.75V8.371zM8.5 5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1"
}))));
export default SvgChannelPhoto14;